<template>
  <div class="row mx-auto">
    <div class="col-12 col-md-12">
      <div class="row pt-4 mb-3">
        <div class="col-12">
          <div style="margin-bottom: 24px;" class="d-flex justify-content-between">
            <a v-if="isProfile" class="back-button" @click="onClick" style="cursor: pointer">
              <img v-bind:src="'/images/arrow_back_blue.svg'" alt style="margin: 0 4px 4px 0;" />
              Back
            </a>
            <a v-else class="back-button" href="javascript:history.go(-1)" style="cursor: pointer">
              <img v-bind:src="'/images/arrow_back_blue.svg'" alt style="margin: 0 4px 4px 0;" />
              Back
            </a>
            <!-- <a class="back-button" @click="onClick" style="cursor: pointer">
              <img v-bind:src="'/images/arrow_right.png'" alt style="margin: 0 4px 4px 0;" /> Profile
            </a>-->
          </div>
        </div>
      </div>

      <edit-remote-readiness></edit-remote-readiness>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClick() {
      this.$emit("onClick");
    }
  },

  computed: {
    isProfile() {
      return window.location.pathname === "/profile";
    }
  }
};
</script>

<style scoped lang="scss">
.back-button {
  color: #0db4e6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
}
</style>
